import { isNotBlankValue } from '../objects/isBlankValue';
import { isNotEmpty } from '../objects/isEmpty';

/**
 * Filter out null, undefined, or any empty strings
 *
 * @param values
 * @returns
 */
export function filterBlank<T>(values: Array<T | undefined | null> | undefined | null): T[] {
	if (!values?.length) {
		return [];
	}

	// Need to wrap so that we don't pass extra parameters from filter to the downstream function
	return values.filter((value) => isNotBlankValue(value));
}

/**
 * Filter out null, undefined, empty strings, empty arrays, or empty objects (evaluated recursively)
 *
 * @param values
 * @returns
 */
export function filterEmpty<T>(values: Array<T | undefined | null> | undefined | null): T[] {
	const notBlank = filterBlank(values);

	// Need to wrap so that we don't pass extra parameters from filter to the downstream function
	return notBlank.filter((value) => isNotEmpty(value));
}
